interface UniversityOption {
  name: string;
}

const DEGREE_VALUES = ["bachelor", "master", "phd", "college", "secondary_general"];

const DEGREE_KEYWORDS: [string, string][] = [
  ["бакалавр", "bachelor"],
  ["bachelor", "bachelor"],
  ["магистр", "master"],
  ["master", "master"],
  ["доктор", "phd"],
  ["кандидат", "phd"],
  ["phd", "phd"],
  ["ph.d", "phd"],
  ["среднее профессиональное", "college"],
  ["среднее специальное", "college"],
  ["колледж", "college"],
  ["техникум", "college"],
  ["среднее общее", "secondary_general"],
  ["средняя школа", "secondary_general"],
  ["аттестат", "secondary_general"],
  ["среднее", "secondary_general"],
];

export function mapOcrDegree(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const lower = raw.trim().toLowerCase();
  if (lower === "") return null;
  if (DEGREE_VALUES.includes(lower)) return lower;
  for (const [keyword, value] of DEGREE_KEYWORDS) {
    if (lower.includes(keyword)) return value;
  }
  return null;
}

function normalizeUniversity(value: string): string {
  return value
    .toLowerCase()
    .replace(/["'«»“”]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function resolveUniversityForOcr(raw: string | null | undefined, universities: UniversityOption[]): string | null {
  if (!raw) return null;
  const normalizedRaw = normalizeUniversity(raw);
  if (normalizedRaw === "") return null;
  if (!universities || universities.length === 0) return null;

  const exact = universities.find((u) => normalizeUniversity(u.name) === normalizedRaw);
  if (exact) return exact.name;

  const contained = universities.find((u) => {
    const name = normalizeUniversity(u.name);
    return name.includes(normalizedRaw) || normalizedRaw.includes(name);
  });
  if (contained) return contained.name;

  return null;
}
